module.exports = __webpack_public_path__ + "static/media/black-rectangle-measure-icon.6ae80493.svg";